// src/data/AwarenessEventContent.js

// Import individual static data files
import { earthDayFAQs } from './AwarenessFAQData';
import { awarenessSpeeches, aiPrompts } from './AwarenessSpeechData';
import { earthDayActivities } from './AwarenessActivitiesData';
import { awarenessProjects } from './AwarenessProjectsData';

// This object will hold content for different awareness events, keyed by a unique identifier.
// For Earth Day, we'll use its common date format "MM-DD" as a key for simplicity,
// but in a real backend scenario, you might use a unique event ID.
export const awarenessEventContent = {
  // Key for Earth Day (April 22nd)
  '04-22': { // Using MM-DD format as a key for fixed-date events
    details: {
      faqs: earthDayFAQs,
      // Add other general details if needed here that are specific to Earth Day
    },
    speeches: {
      staticSpeeches: awarenessSpeeches,
      aiPrompts: aiPrompts,
    },
    activities: {
      staticActivities: earthDayActivities,
    },
    projects: {
      staticProjects: awarenessProjects,
    },
  },
  // You can add more events here in the future:
  /*
  '06-05': { // Example: World Environment Day (June 5th)
    details: {
      faqs: [
        { id: 'wed-why', question: 'Why is World Environment Day Celebrated?', answer: '...' }
      ],
    },
    speeches: { ... },
    activities: { ... },
    projects: { ... },
  },
  'some-unique-event-id': { // Example: for events identified by ID
    details: { ... },
    speeches: { ... },
    activities: { ... },
    projects: { ... },
  },
  */ 
};
